import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import PatientDetails from "./editRadiologyReport/patientDetails";
import CertificateDetails from "./editRadiologyReport/certificateDetails";
import ServiceDetails from "./editRadiologyReport/serviceDetails";
import Remark from "./editRadiologyReport/remark";
import Assigne from "./editRadiologyReport/assigne";
import CertificateStatus from "./editRadiologyReport/certificateStatus";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import {
  getAllMedicalCertificate,
  updateMedicalCertificate,
  resetCreateHealthScreeningMessage,
} from "../../../store/slices/medicalCertificate.slice";

const EditMedicalCertificate = () => {
  const dispatch = useDispatch();
  const showMessageAndReset = ShowTostifyMessageAndReset();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const {
    medicalCertificate,
    updateMedicalCertificateSuccessMessage,
    updateMedicalCertificateErrorMessage,
  } = useSelector((state) => state.medicalCertificate);
  const { userInfo, token } = useSelector((state) => state.auth);
  const medicalCertificateId = sessionStorage.getItem("medicalCertificateId");
  const newMedicalCertificate = medicalCertificate[0];
  const [medicalCertificateFormData, setMedicalCertificateFormData] = useState({
    appointmentId: "",
    patientId: "",
    clinicId: "",
    referredBy: "",
    physicianId: "",
    testDetails: [
      {
        tests: "",
        testResults: "",
      },
    ],
    profilesDetails: [
      {
        profiles: "",
        profileResults: "",
      },
    ],
    radiologyDetails: [
      {
        serviceDetails: "",
        radiologyResults: "",
      },
    ],
    passportNumber: "",
    nationality: "",
    religion: "",
    maritalStatus: "",
    postAppliedFor: "",
    appliedCountry: "",
    projectName: "",
    height: "",
    weight: "",
    BMI: "",
    eye: {
      r_eye: "",
      l_eye: "",
    },
    ear: {
      r_ear: "",
      l_ear: "",
    },
    SECV: {
      BP: "",
      pulse: "",
      heart: "",
    },
    respiratorySystem: {
      throat: "",
      lungs: "",
    },
    gastroIntestinal: {
      abdomen: "",
      CNS: "",
      skin: "",
      psychatry: "",
    },
    other: {
      hydrocele: "",
      hernia: "",
      vericosVeins: "",
      extremities: "",
      deformities: "",
    },
    abnormalFinding: "",
    remark: "",
    medicalStatus: "",
    certificateStatus: "",
  });
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  useEffect(() => {
    dispatch(
      getAllMedicalCertificate({
        clinicId,
        reportId: medicalCertificateId,
        token,
      }),
    );
  }, [dispatch, clinicId, medicalCertificateId, token]);

  useEffect(() => {
    setMedicalCertificateFormData((prevState) => ({
      ...prevState,
      appointmentId: newMedicalCertificate?.appointmentId,
      patientId: newMedicalCertificate?.patientId?._id,
      clinicId: newMedicalCertificate?.clinicId?._id,
      referredBy: newMedicalCertificate?.referredBy?._id,
      physicianId: newMedicalCertificate?.physicianId?._id,
      physicianName: newMedicalCertificate?.physicianId?.userId?.name,
      testDetails: newMedicalCertificate?.testDetails.map((test) => ({
        tests: test?.tests?._id,
        testResults: test?.testResults || "",
      })),
      profilesDetails: newMedicalCertificate?.profilesDetails.map(
        (profile) => ({
          profiles: profile?.profiles?._id,
          profileResults: profile?.profileResults || "",
        }),
      ),
      radiologyDetails: newMedicalCertificate?.radiologyDetails?.map(
        (item) => ({
          serviceDetails: item?.serviceDetails?._id,
          radiologyResults: item?.radiologyResults || "",
        }),
      ),
      passportNumber: newMedicalCertificate?.passportNumber,
      nationality: newMedicalCertificate?.nationality,
      religion: newMedicalCertificate?.religion,
      maritalStatus: newMedicalCertificate?.maritalStatus || "",
      postAppliedFor: newMedicalCertificate?.postAppliedFor,
      appliedCountry: newMedicalCertificate?.appliedCountry,
      projectName: newMedicalCertificate?.projectName,
      height: newMedicalCertificate?.height,
      weight: newMedicalCertificate?.weight,
      BMI: newMedicalCertificate?.BMI,
      eye: {
        r_eye: newMedicalCertificate?.eye?.r_eye,
        l_eye: newMedicalCertificate?.eye?.l_eye,
      },
      ear: {
        r_ear: newMedicalCertificate?.ear?.r_ear,
        l_ear: newMedicalCertificate?.ear?.l_ear,
      },
      SECV: {
        BP: newMedicalCertificate?.SECV?.BP,
        pulse: newMedicalCertificate?.SECV?.pulse,
        heart: newMedicalCertificate?.SECV?.heart,
      },
      respiratorySystem: {
        throat: newMedicalCertificate?.respiratorySystem?.throat,
        lungs: newMedicalCertificate?.respiratorySystem?.lungs,
      },
      gastroIntestinal: {
        abdomen: newMedicalCertificate?.gastroIntestinal?.abdomen,
        CNS: newMedicalCertificate?.gastroIntestinal?.CNS,
        skin: newMedicalCertificate?.gastroIntestinal?.skin,
        psychatry: newMedicalCertificate?.gastroIntestinal?.psychatry,
      },
      other: {
        hydrocele: newMedicalCertificate?.other?.hydrocele,
        hernia: newMedicalCertificate?.other?.hernia,
        vericosVeins: newMedicalCertificate?.other?.vericosVeins,
        extremities: newMedicalCertificate?.other?.extremities,
        deformities: newMedicalCertificate?.other?.deformities,
      },
      abnormalFinding: newMedicalCertificate?.abnormalFinding,
      medicalStatus: newMedicalCertificate?.medicalStatus,
      remark: newMedicalCertificate?.remark,
      certificateStatus: newMedicalCertificate?.certificateStatus,
    }));
  }, [dispatch, newMedicalCertificate, clinicInfo]);

  useEffect(() => {
    showMessageAndReset(
      updateMedicalCertificateSuccessMessage,
      showToastifySuccess,
      resetCreateHealthScreeningMessage,
    );
    showMessageAndReset(
      updateMedicalCertificateErrorMessage,
      showToastifyError,
      resetCreateHealthScreeningMessage,
    );
  }, [
    dispatch,
    showMessageAndReset,
    updateMedicalCertificateSuccessMessage,
    updateMedicalCertificateErrorMessage,
  ]);

  const handleChange = (e, name) => {
    if (name === "doctor") {
      setMedicalCertificateFormData({
        ...medicalCertificateFormData,
        physicianId: e.value,
        physicianName: e.label,
      });
    } else if (name === "medicalStatus") {
      setMedicalCertificateFormData({
        ...medicalCertificateFormData,
        medicalStatus: e.value,
      });
    } else if (name === "eye") {
      setMedicalCertificateFormData({
        ...medicalCertificateFormData,
        eye: {
          ...medicalCertificateFormData.eye,
          [e.target.name]: e.target.value,
        },
      });
    } else if (name === "ear") {
      setMedicalCertificateFormData({
        ...medicalCertificateFormData,
        ear: {
          ...medicalCertificateFormData.ear,
          [e.target.name]: e.target.value,
        },
      });
    } else if (name === "SECV") {
      setMedicalCertificateFormData({
        ...medicalCertificateFormData,
        SECV: {
          ...medicalCertificateFormData.SECV,
          [e.target.name]: e.target.value,
        },
      });
    } else if (name === "respiratorySystem") {
      setMedicalCertificateFormData({
        ...medicalCertificateFormData,
        respiratorySystem: {
          ...medicalCertificateFormData.respiratorySystem,
          [e.target.name]: e.target.value,
        },
      });
    } else if (name === "gastroIntestinal") {
      setMedicalCertificateFormData({
        ...medicalCertificateFormData,
        gastroIntestinal: {
          ...medicalCertificateFormData.gastroIntestinal,
          [e.target.name]: e.target.value,
        },
      });
    } else if (name === "other") {
      setMedicalCertificateFormData({
        ...medicalCertificateFormData,
        other: {
          ...medicalCertificateFormData.other,
          [e.target.name]: e.target.value,
        },
      });
    } else {
      const { name: fieldName, value } = e.target;

      setMedicalCertificateFormData((prev) => {
        const updated = {
          ...prev,
          [fieldName]: value,
        };

        // ✅ BMI Calculation
        if (fieldName === "height" || fieldName === "weight") {
          const heightInMeters = parseFloat(updated.height) / 100;
          const weight = parseFloat(updated.weight);

          if (heightInMeters > 0 && weight > 0) {
            updated.BMI = (weight / (heightInMeters * heightInMeters)).toFixed(
              2,
            );
          } else {
            updated.BMI = "";
          }
        }

        return updated;
      });
    }
  };

  const handleServiceChange = (e, name, index) => {
    if (name === "testDetails") {
      setMedicalCertificateFormData((prevState) => {
        const updatedTests = prevState.testDetails.map((test) => {
          if (test?.tests === index) {
            return {
              ...test,
              testResults: e?.value || e?.label || test.testResults,
            };
          }
          return test;
        });
        return {
          ...prevState,
          testDetails: updatedTests,
        };
      });
    } else if (name === "profilesDetails") {
      setMedicalCertificateFormData((prevState) => {
        const updatedProfiles = prevState.profilesDetails.map((profile) => {
          if (profile?.profiles === index) {
            return {
              ...profile,
              profileResults: e?.value || e?.label || profile.profileResults,
            };
          }
          return profile;
        });
        return {
          ...prevState,
          profilesDetails: updatedProfiles,
        };
      });
    } else if (name === "radiologyDetails") {
      setMedicalCertificateFormData((prevState) => {
        const updatedRadiology = prevState.radiologyDetails.map((radiology) => {
          if (radiology?.serviceDetails === index) {
            return {
              ...radiology,
              radiologyResults:
                e?.value || e?.label || radiology?.radiologyResults,
            };
          }
          return radiology;
        });
        return {
          ...prevState,
          radiologyDetails: updatedRadiology,
        };
      });
    }
  };
  const handleAddDescription = (data, name) => {
    const updatedDescription = data.getData();
    if (name === "abnormalFinding") {
      setMedicalCertificateFormData({
        ...medicalCertificateFormData,
        abnormalFinding: updatedDescription,
      });
    } else if (name === "remark") {
      setMedicalCertificateFormData({
        ...medicalCertificateFormData,
        remark: updatedDescription,
      });
    }
  };

  const handleUpdateHealthScreeningCertificate = (e) => {
    e.preventDefault();
    dispatch(
      updateMedicalCertificate({
        ...medicalCertificateFormData,
        id: newMedicalCertificate?._id,
        updatedBy: userInfo?._id,
        token,
      }),
    );
  };

  const handleIndividualLabChange = (selectedOption, id, type) => {
    setMedicalCertificateFormData((prevState) => ({
      ...prevState,
      [type]: prevState[type].map((item) =>
        item.id === id
          ? { ...item, labForOutsource: selectedOption.value }
          : item,
      ),
    }));
  };
  return (
    <>
      <form onSubmit={handleUpdateHealthScreeningCertificate}>
        <PatientDetails
          medicalCertificate={newMedicalCertificate}
          handleChange={handleChange}
          medicalCertificateFormData={medicalCertificateFormData}
        />
        <CertificateDetails
          medicalCertificateFormData={medicalCertificateFormData}
          handleChange={handleChange}
          medicalCertificate={newMedicalCertificate}
        />
        <ServiceDetails
          medicalCertificateFormData={medicalCertificateFormData}
          handleChange={handleChange}
          handleServiceChange={handleServiceChange}
          setMedicalCertificateFormData={setMedicalCertificateFormData}
          handleIndividualLabChange={handleIndividualLabChange}
          medicalCertificate={newMedicalCertificate}
        />
        <Assigne
          medicalCertificateFormData={medicalCertificateFormData}
          handleChange={handleChange}
          medicalCertificate={newMedicalCertificate}
        />
        <Remark
          medicalCertificateFormData={medicalCertificateFormData}
          medicalCertificate={newMedicalCertificate}
          handleAddDescription={handleAddDescription}
        />
        <CertificateStatus
          medicalCertificateFormData={medicalCertificateFormData}
          handleChange={handleChange}
          medicalCertificate={newMedicalCertificate}
        />
        <br />
        <div className="text-end">
          <Button variant="primary" type="submit" className="p-2">
            Submit
          </Button>
        </div>
      </form>
    </>
  );
};

export default EditMedicalCertificate;
